import { Typography, Flex } from 'antd';

const { Title, Text } = Typography;

const ImageOverlay = ({ description, mediaItemUrl, altText }) => {
  const cleanDescription = description ? description
    .replace(/<\/?[^>]+(>|$)|\n/g, "")
    .trim() : ''
	return (
		<>
		<Flex className='Image'>
			<div className="OverlayText">
				<div className='OverlayText-space'></div>
				<div className='OverlayText-content'>
					<Title level={3}>
						{altText || ''}
					</Title>
					<Text>{cleanDescription}</Text>
				</div>
			</div>
			<div className='Image-bg'
				style={{
					backgroundImage: `url(${mediaItemUrl})`
				}}
			/>
		</Flex>
		</>
	);
}

export default ImageOverlay